<div class="host-create-house-type">
  <div class="pb-[30px]">
    <nz-alert nzShowIcon [nzMessage]="'house.create_house_type_info' | translate"></nz-alert>
  </div>

  <div class="v4-layout-form v4-layout-form-vertical" [formGroup]="form">
    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "word.name" | translate }}
        <!-- Name -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <input
            formControlName="title"
            type="text"
            nz-input
            nzSize="large"
            [placeholder]="'room_types.create_modal.placeholder.name' | translate"
          />
        </div>
      </div>
    </div>

    <div class="v4-layout-field">
      <div class="v4-layout-field-label">
        {{ "room_types.create_modal.label_include_house" | translate }}
        <!-- Rooms included -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-radio-group [(ngModel)]="typeOfAddHouse" [ngModelOptions]="{ standalone: true }">
            <label nz-radio class="h-8 leading-none" [nzValue]="0">
              {{ "room_types.create_modal.opt_create_house" | translate }}
              <!-- Create new rooms(properties) -->
            </label>
            <br />
            <label nz-radio class="h-8 leading-none" [nzValue]="1">
              {{ "room_types.create_modal.opt_select_current" | translate }}
              <!-- Select rooms(properties) -->
            </label>
          </nz-radio-group>
        </div>
      </div>
    </div>

    <div class="v4-layout-field" *ngIf="typeOfAddHouse === 0">
      <div class="v4-layout-field-label">
        {{ "room_types.create_modal.label_house_count" | translate }}
        <!-- Number of rooms -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row">
          <nz-input-number
            [nzPlaceHolder]="'room_types.create_modal.label_house_count' | translate"
            formControlName="house_count"
            class="w-full"
            [nzMin]="0"
            nzSize="large"
          ></nz-input-number>
        </div>
      </div>
    </div>

    <div class="v4-layout-field" *ngIf="typeOfAddHouse === 1">
      <div class="v4-layout-field-label">
        {{ "house.house_contains_in_house_type" | translate }}
        <!-- Rooms -->
      </div>
      <div class="v4-layout-field-control">
        <div class="v4-option-list">
          <div class="v4-option-item" *ngFor="let opt of selectedHouseList; let i = index">
            <div class="v4-option">
              {{ opt.label }}
              <i class="ml-2" nz-icon nzType="close" nzTheme="outline" (click)="onRemoveSelectedHouse(i)"></i>
            </div>
          </div>
        </div>
        <div class="v4-layout-field-row">
          <a nz-button nzType="link" (click)="onAddHouse()"
            >+ {{ "room_types.create_modal.btn_add_house" | translate }}</a
          >
          <!-- <nz-input-number formControlName="house_count" class="w-full" [nzMin]="0" nzSize="large"
            ></nz-input-number
          > -->
        </div>
      </div>
    </div>
  </div>

  <div class="footer flex flex-row items-center justify-between">
    <div class="ml-auto">
      <button nz-button nzSize="large" (click)="cancel()">
        {{ "word.cancel" | translate }}
      </button>
      <button class="ml-3" nz-button nzSize="large" nzType="primary" (click)="save()">
        {{ "word.save" | translate }}
      </button>
    </div>
  </div>

  <!-- <div class="htc-container" *ngIf="false">
    <div class="top">
      <div class="info">
        <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
        <p>
          此名称仅内部使用，建议简短
          {{ "room_types.create_modal.tip" | translate }}
        </p>
      </div>
      <form nz-form [formGroup]="form" class="form">
        <nz-form-item class="house-type-form-item flex flex-row flex-nowrap items-center">
          <div class="form-title">
            房型名称：
            {{ "room_types.create_modal.label_name" | translate }}
          </div>
          <nz-form-control>
            <host-input-with-error
              [showError]="checking && (!form.get('name').value || form.get('name').value === '')"
              errorText="{{ 'errorText.house_type_name_required' | translate }}"
            >
              <input
                nz-input
                formControlName="name"
                id="name"
                class="name-input"
                placeholder="{{ 'room_types.create_modal.placeholder.name' | translate }}"
              />
            </host-input-with-error>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item class="house-type-form-item flex flex-row flex-nowrap items-center">
          <div class="form-title">
            包含房间：
            {{ "room_types.create_modal.label_include_house" | translate }}
          </div>
          <nz-form-control>
            <nz-radio-group formControlName="createType">
              <label nz-radio [nzValue]="0">
                {{ "room_types.create_modal.opt_create_house" | translate }}
                创建新房间
              </label>
              <label nz-radio [nzValue]="1">
                {{ "room_types.create_modal.opt_select_current" | translate }}
                选择已有房间
              </label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item
          class="house-type-form-item flex flex-row flex-nowrap items-center"
          *ngIf="form.get('createType').value === 0"
        >
          <div class="form-title">
            {{ "room_types.create_modal.label_house_count" | translate }}
            房间数：
          </div>
          <nz-input-group nzCompact style="width: auto">
            <button nz-button (click)="minus()">
              <i nz-icon nzType="minus" nzTheme="outline"></i>
            </button>
            <input
              type="text"
              nz-input
              style="width: 60px; text-align: center"
              formControlName="houseNumber"
              (blur)="newHouseNumChange()"
            />
            <button nz-button (click)="plus()">
              <i nz-icon nzType="plus" nzTheme="outline"></i>
            </button>
          </nz-input-group>
        </nz-form-item>
        <div
          class="choose-houses house-type-form-item flex flex-row flex-nowrap items-center"
          *ngIf="form.get('createType').value === 1"
        >
          <div class="form-title">
            {{ "room_types.create_modal.label_house" | translate }}
            房间：
          </div>
          <div class="operate-houses">
            <div class="houses" *ngIf="houseList.length > 0">
              <div class="house" *ngFor="let house of houseList">
                <p>{{ house.house_title }}</p>
                <div class="delete" (click)="delete(house)">X</div>
              </div>
            </div>
            <div class="add-house" (click)="addHouse()">
              <i nz-icon nzType="plus" nzTheme="outline"></i>&nbsp;
              添加房间
              {{ "room_types.create_modal.btn_add_house" | translate }}
            </div>
            <span
              *ngIf="houseTypeForm.get('createType').value === 1 && checking && houseList.length === 0"
              style="color: #f45a5a; font-size: 12px"
            >
              <i nz-icon nzType="exclamation-circle" nzTheme="outline"></i>
              请添加房间
              {{ "errorText.add_house_required" | translate }}
            </span>
          </div>
        </div>
      </form>
    </div>
  </div> -->
</div>
